import { limitListElements } from '../utils/utils.js';

document
  .querySelectorAll('.references-documentaires-type')
  .forEach((element) => {
    const valueElement = element.querySelector('.clampLines');
    if (valueElement != null) {
      limitListElements(valueElement, 5);
    }
  });
